import { useMutation } from "react-query";
import generateTwoFASecretKey from "../services/generateTwoFASecretKey";

function useGenerateTwoFASK() {
  return useMutation(["generateTwoFASecretKey"], generateTwoFASecretKey);
}

export default useGenerateTwoFASK;
